/* eslint-disable import/no-unresolved */
import React from 'react';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import Container from '../../VuexyDesign/atoms/Container';
import styles from '../../style/scss/modules/HeroSection.module.scss';
import { useIsDesktop } from '../../style/constants';
// eslint-disable-next-line import/order

export function HeroSection() {
  const { t } = useTranslation('howItWorks');
  const isDesktop = useIsDesktop();

  return (
    <>
      <div
        className={styles.heroBanner}
        style={{
          background: "url('/static/images/how-it-works-banner-front.webp')",
        }}
      >
        <div className={styles.overlay} />
        <Container className="z-1 position-relative">
          <Link href="/how-it-works">
            <span
              className="custom-font-text-small-normal text-white pr-2"
              style={{ cursor: 'pointer' }}
            >
              <u>{t('howItWorks:howItWorks')}</u>
            </span>
          </Link>
          <span className="custom-font-text-small-medium text-primary">
            {t('howItWorks:whatAreVcoinsPage.vcoins') as string}
          </span>
          <h1
            className={`text-white font-weight-bolder ${
              isDesktop ? 'display-3' : 'display-5'
            }`}
          >
            {t('howItWorks:whatAreVcoinsPage.title')}
          </h1>
          <span
            className={`custom-font-text-small-normal text-white ${
              isDesktop ? 'w-50' : 'w-100'
            } pb-1`}
          >
            {t('howItWorks:whatAreVcoinsDescriptions.headerText')}
          </span>
        </Container>
      </div>
    </>
  );
}

export default HeroSection;
